export function calculatePercentage(value: number, total: number) {
  return (value * 100) / Math.trunc(total);
}

export function valueFromPercentage(percent: number, total: number) {
  return (percent * total) / 100;
}